<template>
  <div class="navbar" v-if="user">
    <div class="brand" :class="{active:$route.name === 'dashboard'}">
      <router-link to="/">
        <span>ISACC</span>
      </router-link>
    </div>
    <ul class="left_nav_list" v-if="permissions.length">
      <li>
        <div  data-toggle="accordion" data-target="#page"  class="left_f_list">
          <a role="button"><i class='bx bx-note'></i><span>Pages</span></a>
        </div>
        <ul class="sub_accordion first_level" id="page" v-if="pageTypes">
          <template v-if="checkPermission('page')">
            <li v-for="page in pageTypes" :key="'page'+page.id"><router-link :to="{name:'pages', params:{type:page.id}}"> {{ page.name }}</router-link></li>
          </template>
          <template v-if="checkPermission('custom_page')">
            <li v-if="customPages">
              <div  data-toggle="collapse" data-target="#custompage"  class="left_f_list">
                <a role="button" class="sub_category"><span>Custom pages </span></a>
              </div>
              <ul class="sub_accordion first_level" id="custompage">
                <li v-for="page in customPages" :key="'page_'+page.id"><router-link :to="{name:'custom_page', params:{slug:page.slug}}">{{ page.name }}</router-link></li>
              </ul>
            </li>
          </template>
          <template v-if="checkPermission('blogs')">
            <li><router-link :to="{name:'blogs'}"> Blogs</router-link></li>
          </template>
<!--          <template v-if="checkPermission('news')">-->
<!--            <li><router-link :to="{name:'news'}">News</router-link></li>-->
<!--          </template>-->
<!--          <template v-if="checkPermission('gallery')">-->
<!--            <li><router-link :to="{name:'gallery'}">Gallery</router-link></li>-->
<!--          </template>-->
<!--          <template v-if="checkPermission('lecture')">-->
<!--            <li><router-link :to="{name:'lecture'}"> Lecture</router-link></li>-->
<!--          </template>-->
<!--          <template v-if="checkPermission('board')">-->
<!--            <li><router-link :to="{name:'board'}"> Board</router-link></li>-->
<!--          </template>-->
        </ul>
      </li>
      <template v-if="checkPermission('banner')">
        <li>
          <div  data-toggle="accordion" data-target="#BannerManager"  class="left_f_list">
            <a role="button"><i class='bx bx-slider-alt'></i><span>Banners </span></a>
          </div>
          <ul class="sub_accordion first_level" id="BannerManager">
            <li v-for="slider in sliders" :key="'slider'+slider.id"><router-link :to="{name:'banner_list', params:{type:slider.id}}"> {{ slider.name }} </router-link></li>
          </ul>
        </li>
      </template>
     <!-- <li>
       <div  data-toggle="accordion" data-target="#blogs"  class="left_f_list">
         <a role="button"><i class='bx bxl-blogger'></i><span>Blogs</span></a>
       </div>
       <ul class="sub_accordion first_level" id="blogs" >
         <li><router-link :to="{name:'blogs_add'}"> New Blog</router-link></li>
         <li><router-link :to="{name:'blogs'}"> All Blogs</router-link></li>
       </ul>
     </li>
     <li>
       <div  data-toggle="accordion" data-target="#news"  class="left_f_list">
         <a role="button"><i class='bx bx-news'></i><span>News</span></a>
       </div>
       <ul class="sub_accordion first_level" id="news" >
         <li><router-link :to="{name:'news_add'}"> New News</router-link></li>
         <li><router-link :to="{name:'news'}"> All News</router-link></li>
       </ul>
     </li>
     <li>
       <div  data-toggle="accordion" data-target="#Gallery"  class="left_f_list">
         <a role="button"><i class='bx bx-images' ></i> <span>Galleries</span></a>
       </div>
       <ul class="sub_accordion first_level" id="Gallery">
         <li><router-link :to="{name:'gallery'}"> All Gallery</router-link></li>
       </ul>
     </li> -->
      <template v-if="checkPermission('notice')">
        <li>
          <div  data-toggle="accordion" data-target="#notice"  class="left_f_list">
            <a role="button"><i class='bx bxs-notepad'></i> <span>Notices</span></a>
          </div>
          <ul class="sub_accordion first_level" id="notice">
            <li><router-link :to="{name:'notice'}"> Notice</router-link></li>
            <li><router-link :to="{name:'scroll_notice'}">Scroll Notice</router-link></li>
          </ul>
        </li>
      </template>
      <template v-if="checkPermission('user')">
      <li>
        <div  data-toggle="accordion" data-target="#users"  class="left_f_list">
          <a role="button"><i class='bx bx-user'></i> <span>Users</span></a>
        </div>
        <ul class="sub_accordion first_level" id="users">
          <li><router-link :to="{name:'users'}">User List</router-link></li>
        </ul>
      </li>
      </template>
      
      <template v-if="checkPermission('customer')">
        <li>
          <div  data-toggle="accordion" data-target="#customers"  class="left_f_list">
            <a role="button"><i class='bx bx-user'></i> <span>Customers</span></a>
          </div>
          <ul class="sub_accordion first_level" id="customers">
            <li><router-link :to="{name:'customers'}">Customer List</router-link></li>
          </ul>
        </li>
      </template>
     <!-- <li>
       <div  data-toggle="accordion" data-target="#scroll-notice"  class="left_f_list">
         <a role="button"><i class='bx bx-note'></i> <span>Scroll Notice</span></a>
       </div>
       <ul class="sub_accordion first_level" id="scroll-notice">
         <li><router-link :to="{name:'scroll_notice_add'}"> New Scroll Notice</router-link></li>
         <li><router-link :to="{name:'scroll_notice'}"> All Scroll Notice</router-link></li>
       </ul>
     </li>
     <li>
       <div  data-toggle="accordion" data-target="#lecture"  class="left_f_list">
         <a role="button"><i class='bx bx-book-open'></i> <span>Lecture</span></a>
       </div>
       <ul class="sub_accordion first_level" id="lecture">
         <li><router-link :to="{name:'lecture_add'}"> New Lecture</router-link></li>
         <li><router-link :to="{name:'lecture'}"> All Lecture</router-link></li>
       </ul>
     </li>
     <li>
       <div  data-toggle="accordion" data-target="#board"  class="left_f_list">
         <a role="button"><i class='bx bx-clipboard'></i> <span>Boards</span></a>
       </div>
       <ul class="sub_accordion first_level" id="board">
         <li><router-link :to="{name:'board_add'}"> New Board</router-link></li>
         <li><router-link :to="{name:'board'}"> All Board</router-link></li>
       </ul>
     </li> -->

    </ul>
    <div class="bottom_menu" v-if="user">
      <div class="header_left">
        <div class="user_dropdown_wrap">
          <button class="user_dropdown"  @click="openMenu">
            <img src="/images/author.png" alt="">
            <div class="text">
              <h2>{{ user ? user.name : ''}}</h2>
<!--              <p>admin</p>-->
            </div>
          </button>
          <div class=" user_dropdown_menu left">
            <ul>
              <li>
                <router-link :to="{name:'settings'}"> <i class="ti-settings"></i> Setting</router-link>
              </li>
              <li><a role="button" class="logout_button" @click.prevent="logout"><i class="ti-lock"></i> Logout</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
      customPages: [],
      sliders: [],
    }
  },
  computed:{
    ...mapGetters({
      pageTypes:"getPageTypes",
      permissions:"auth/getPermissions",
      user: 'auth/getUser'
    })
  },
  created() {
    this.axios.get('/get-custom-pages').then((response) => {
      this.customPages = response.data.data
    })
    this.axios.get('/sliders/types').then((response) => {
      this.sliders = response.data
    })
  },
  methods: {
    logout() {
      this.axios.post('/logout').finally(() => {
        this.$store.dispatch('auth/logout')
        this.$router.push({
          name: 'login'
        })
      })
    },
    openMenu(){
      window.$('.user_dropdown_menu').slideToggle();
    }
  }
}
</script>
<style scoped>
.logout_button{
  cursor: pointer;
}
.sub_category{
  padding: 10px 0px !important;
  font-size: 14px !important;
}
</style>
